function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import uniq from 'lodash/uniq';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import { PropertyType } from '@domain-group/fe-allhomes-library';
import { BtrPill } from '@domain-group/fe-co-allhomes-shared-components';
import { AllhomesListingBadges } from '@domain-group/fe-co-allhomes-listing-badges';
import { Images } from './components/images';
import { ChildList } from './components/child-list';
import { Details } from './components/details';
import { Overview } from './components/overview';
import * as styles from './new-homes-search-result-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Card = props => ___EmotionJSX("div", _extends({
  css: styles.newDevelopmentCard
}, props));
var CardBody = props => ___EmotionJSX("div", _extends({
  css: styles.cardBody
}, props));
var ParentSection = props => ___EmotionJSX("div", _extends({
  css: styles.parentSection
}, props));
var ChildSection = props => ___EmotionJSX("div", _extends({
  css: styles.childSection
}, props));
export var NewHomesSearchResultCard = _ref => {
  var _development$backgrou, _development$foregrou, _development$logo, _listing$url;
  var listing = _ref.listing,
    address = _ref.address,
    development = _ref.development,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'vertical' : _ref$layout;
  var isBtr = (development === null || development === void 0 ? void 0 : development.type) === 'RENTAL';
  var buildPhotoAlt = (name, _ref2) => {
    var street = _ref2.street,
      suburb = _ref2.suburb,
      state = _ref2.state,
      postcode = _ref2.postcode;
    var streetWithComma = street ? "".concat(street, ",") : '';
    return "".concat(name, " - ").concat([streetWithComma, suburb, state, postcode].filter(value => value).join(' ').trim());
  };
  var buildNewHomesType = () => uniq(development.children.map(item => {
    var _PropertyType$item$pr, _item$property$types;
    return (_PropertyType$item$pr = PropertyType[(_item$property$types = item.property.types) === null || _item$property$types === void 0 ? void 0 : _item$property$types[0]]) === null || _PropertyType$item$pr === void 0 ? void 0 : _PropertyType$item$pr.label;
  }).filter(each => each)).join(', ');
  return ___EmotionJSX(Card, {
    className: className,
    "data-new-dev-layout": layout
  }, ___EmotionJSX(Images, {
    firstImage: listing.firstImage,
    layout: layout,
    alt: buildPhotoAlt(development.name, address),
    logo: {
      backgroundColour: (_development$backgrou = development.backgroundColour) !== null && _development$backgrou !== void 0 ? _development$backgrou : undefined,
      foregroundColour: (_development$foregrou = development.foregroundColour) !== null && _development$foregrou !== void 0 ? _development$foregrou : undefined,
      url: (_development$logo = development.logo) !== null && _development$logo !== void 0 ? _development$logo : undefined,
      name: development.name
    }
  }, ___EmotionJSX("div", {
    css: styles.badges
  }, ___EmotionJSX(AllhomesListingBadges, {
    annotations: listing.annotations,
    labelType: "short"
  })), layout !== 'three-column' && ___EmotionJSX(Overview, {
    name: development.name,
    title: listing.title,
    layout: layout
  })), ___EmotionJSX(CardBody, null, ___EmotionJSX(ParentSection, null, layout === 'three-column' && ___EmotionJSX(Overview, {
    name: development.name,
    title: listing.title,
    layout: layout
  }), ___EmotionJSX(Details, {
    address: address,
    type: buildNewHomesType(),
    href: listing.url,
    listingId: listing.id,
    onClick: () => {
      _onClick(listing.id);
    }
  }), isBtr && ___EmotionJSX("div", {
    css: styles.pills
  }, ___EmotionJSX(BtrPill, null))), ___EmotionJSX(ChildSection, null, ___EmotionJSX("div", {
    css: styles.childrenLinkContainer
  }, ___EmotionJSX(ChildList, {
    listings: development.children,
    layout: layout
  })), ___EmotionJSX("a", {
    css: styles.childrenLink,
    href: (_listing$url = listing.url) !== null && _listing$url !== void 0 ? _listing$url : undefined
  }, "View entire development", ___EmotionJSX(ChevronRightIcon, {
    size: "custom",
    css: styles.childrenLinkArrow
  })))));
};